export default "/_next/static/images/woofwooftvlogo-29b49bc97859efe0e6b4daa4d67cc4b7.svg";